module.exports = __webpack_public_path__ + "img/404.0c709a5b.png";